import { Check } from "lucide-react";
import { useLayoutEffect, useRef } from "react";
import type { Halt } from "./karteHalten";

/** Abbild des Kartenkopfs für den Platz: nur das Bild, ohne Kennungen, Ziele und Tab-Stopps (der Platz ist `inert`). */
function abbild(kopf: HTMLElement): HTMLElement {
  const kopie = kopf.cloneNode(true) as HTMLElement;
  for (const el of [kopie, ...kopie.querySelectorAll<HTMLElement>("*")]) {
    for (const name of ["id", "data-testid", "href", "tabindex", "aria-label", "aria-describedby", "data-geist-ziel"]) el.removeAttribute(name);
  }
  return kopie;
}

/** Der Platz der gegangenen Karte (gleiche Höhe, Bezug des Mitgleitens); steht die Karte noch, nichts. W82 Web-5h-N1 (Frage 66 = B,
 *  D-677): er zeigt den Erfolgszustand der Karte (ihr Kopf, Haken, „Abgelegt in …“) statt einer leeren Glasfläche, bis die Antwort
 *  des Gaist fertig ist; nur Bild (`aria-hidden`, `inert`), die Meldung hat die Karte schon vorgelesen. */
export function KartenPlatz(props: { halt: Halt | null; karte: string | undefined }) {
  const kopf = useRef<HTMLDivElement>(null);
  const halt = props.halt && props.halt.id !== props.karte ? props.halt : null;
  useLayoutEffect(() => {
    const ziel = kopf.current;
    if (ziel && halt?.kopf) ziel.replaceChildren(abbild(halt.kopf));
  }, [halt]);
  if (!halt) return null;
  return (
    <li
      aria-hidden="true"
      inert
      className="karte-platz zeile relative list-none"
      data-abgelegt={halt.erfolg ? "" : undefined}
      data-geist-bezug={halt.id}
      data-testid="karte-platz"
      style={{ height: halt.hoehe }}
    >
      {halt.kopf && <div ref={kopf} className="karte-platz-kopf" />}
      {halt.erfolg && (
        <p className="erfolg linie-oben t-body flex items-center gap-3 px-4 py-4 font-semibold text-pg-ok">
          <span className="grid size-(--size-tile) shrink-0 place-items-center rounded-pill bg-pg-ok-soft">
            <Check size={20} strokeWidth={2} aria-hidden />
          </span>
          Abgelegt in {halt.erfolg}
        </p>
      )}
    </li>
  );
}
